<div class="ad-container">
    <div class="ad-container__left">
        <img class="background-image fuel-ad" src="/assets/img/fuel-ad.png" alt="fuel-ad-img">

        <span class="title">Zyskaj nawet</span>
        <span appDigitalDisplay>23,500</span>
        <span class="title">zł oszczędności na paliwie z pakietem <b>MyCar Business</b>.</span>
    </div>
    <a href="https://up.tekom.pl/" target="_blank" class="ad-container__submit">
        <div class="ad-container__submit__arrow">
            <i class="pi pi-angle-right"></i>
        </div>
        <span class="title">Dowiedz się więcej</span>
    </a>
</div>
